export const REDIRECT_URL = "REDIRECT_URL";
export const REDIRECT_TYPE = "REDIRECT_TYPE";
export const AZUR_TOKEN = "AZUR_TOKEN";

// Inactivity timeout configuration (in milliseconds)
// WARNING_TIMEOUT: Time before showing warning (default: 14 minutes)
// AUTO_LOGOUT_TIMEOUT: Time after warning before auto-logout (default: 1 minute)
// Total inactivity time before logout: WARNING_TIMEOUT + AUTO_LOGOUT_TIMEOUT (15 minutes)
export const INACTIVITY_WARNING_TIMEOUT = 30 * 60 * 1000; // 30 minutes
export const INACTIVITY_AUTO_LOGOUT_TIMEOUT = 2 * 60 * 1000; // 2 minutes

export const ORGNIZATION_REGION = [
  { label: "North America", value: "North America" },
  { label: "Europe", value: "Europe" },
  { label: "South America", value: "South America" },
  { label: "Asia pacific ", value: "Asia pacific" },
];

export const ORGNIZATION_PROGRAM_TYPE = [
  { label: "State", value: "State" },
  { label: "Part B - IDEA", value: "Part B - IDEA" },
  {
    label: "Part C - IDEA Early Intervention",
    value: "Part C - IDEA Early Intervention",
  },
  { label: "Head Start", value: "Head Start" },
  { label: "Early Head Start", value: "Early Head Start" },
  { label: "Tuition Pay (Full)", value: "Tuition Pay (Full)" },
  { label: "Tuition Pay (Partial)", value: "Tuition Pay (Partial)" },
  { label: "Other", value: "Other" },
];

export const ORGNIZATION_LEVEl = [
  { label: "Country", value: "Country" },
  { label: "State", value: "State" },
  {
    label: "District",
    value: "District",
  },
  { label: "School", value: "School" },
  { label: "Classrooms", value: "Classrooms" },
];

export const SUBSCRIPTION_TYPE = [{ label: "Yearly", value: "Yearly" }];

export const USER_ROLES = {
  HIGHSCOPE_ADMIN: "HighscopeAdmin",
  HIGHSCOPE_USER: "User",
  HIGHSCOPE_ORG_USER: "HighscopeOrgAdmin",
};
